/**
 * Web shim for react-native-filament (3D medals).
 *
 * Filament is a native-only 3D engine here; on web the medal area renders
 * empty. Medal3D guards every context member with != null, so inert hooks
 * are enough for its logic to no-op.
 */
const noop = () => {};

module.exports = {
  __esModule: true,
  FilamentScene: ({ children }) => children,
  FilamentView: () => null,
  Model: () => null,
  Camera: () => null,
  DefaultLight: () => null,
  Light: () => null,
  useModel: () => ({ state: 'none', rootEntity: undefined }),
  useFilamentContext: () => ({
    transformManager: undefined,
    engine: undefined,
    engineContext: undefined,
    workletContext: undefined,
  }),
};